<div class="modal-header justify-content-end pb-0 border-0">
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
    </button>
</div>
<div class="modal-body pb-0" tabindex="-1" appFocus [appAutoFocus]="true">
    <section class="settings-wrapper pt-3 pe-0 ps-0">
        @if (isLoading) {
            <sb-loader></sb-loader>
        }
        @if (contactMessages) {
            <div class="table-scroll">
                <table class="sb-table mb-3">
                    <thead>
                        <tr>
                            <th>{{ 'Name' | translate }}</th>
                            <th>{{ 'Date' | translate }}</th>
                            <th>{{ 'Type' | translate }}</th>
                            <th>{{ 'Message source' | translate }}</th>
                            <th>{{ 'Status' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody>
                        @for (message of contactMessages; track message) {
                            <tr>
                                <td>{{ message.name }}</td>
                                <td>{{ message.sendDateTime | date: 'dd.MM.yyyy HH:mm' }}</td>
                                <td>{{ message.type }}</td>
                                <td>{{ message.source }}</td>
                                <td>{{ message.status }}</td>
                            </tr>
                        } @empty {
                            <tr>
                                <td class="no-data" colspan="100">
                                    {{ 'No data available in table' | translate }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <sb-paging
                [activePage]="activePage"
                [itemCount]="totalItems"
                [pageSize]="pageSize"
                (pageChange)="activePage = $event; getContactMessages(activePage)">
            </sb-paging>
        }
    </section>
</div>
